'use strict';

BaseRequesterClassFactory.$inject = ['$q', 'mx.sb.Agent.DataQuery.Row', 'mx.sb.Agent.DataQuery.DataQueryDefinition'];
export default function BaseRequesterClassFactory($q, DataQueryRow, DataQueryDefinition) {
	/**
	 * @ngdoc Class
	 * @name mx.sb.Agent.DataQuery.BaseRequester
	 *
	 * @description
	 * Class Base Requester
	 *
	 */

	function BaseRequester(dataQuery) {
		this.setDataQuery(dataQuery);

		this.options = {};

		this.supportedPreprocessors = {
			search: false,
			paging: false,
			sorting: false,
			columnSearch: false,
			advanceSearch: false,
		};
	}

	BaseRequester.prototype = {
		setDataQuery: function (dataQuery) {
			if (!(dataQuery instanceof DataQueryDefinition)) {
				throw Error('Wrong format of DataQuery');
			}

			this.dataQuery = dataQuery;
		},

		getEntityTypes: async function () {
			return [];
		},

		updateOptions: function (options) {
			angular.extend(this.options, options);
		},

		load: function (/*preprocessors, dataQuery*/) {
			return $q.when({
				items: [],
				totalItems: 0,
			});
		},

		getTotalItems: function () {
			return $q.when(0);
		},

		createEntity: function (entityType) {
			return $q.when({
				_type: entityType,
			});
		},

		createRow: function (entity) {
			var row = new DataQueryRow(entity, {}, this._getDisplayEntity.bind(this));
			return row.initProperties(this.dataQuery.Columns).then(function () {
				return row;
			});
		},

		_getDisplayEntity: function (rawEntity, displayEntity /*, changedColumns*/) {
			return $q.when(displayEntity);
		},

		entitiesEqualityFunction: function (entityA, entityB) {
			return entityA === entityB;
		},

		addRows: function (rows) {
			if (Array.isArray(this.rows)) {
				this.rows.splice.apply(this.rows, [0, 0].concat(rows));
			}
		},

		/*
		if export is needed - implement function exportData.

		exportData: function(/!*requestOptions*!/) {
			return this.$q.when([]);
		}*/
	};

	return BaseRequester;
}
